module.exports = __webpack_public_path__ + "static/img/xtBG.eb31fe0d.png";